var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function nl2br(str) {
    return str.replace(/(\r\n|\r|\n)/g, '<br />');
}
export function targetBlankifyLinks(str) {
    var pattern = /(<a).((?!target="_parent").)(.*?>)/gi;
    return str.replace(pattern, '$1 target="_blank" $2$3');
}
export function formatFileSize(bytes, decimalPoint) {
    if (decimalPoint === void 0) { decimalPoint = 1; }
    if (bytes === 0) {
        return '0 Bytes';
    }
    var kilobyte = 1000;
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(kilobyte));
    if (i > sizes.length) {
        return '';
    }
    return (parseFloat((bytes / Math.pow(kilobyte, i)).toFixed(decimalPoint)) +
        ' ' +
        sizes[i]);
}
export var qConsent = 'qConsent';
export var showConsentIfNeeded = function (form, consentText) {
    var hasInput = false;
    var hasTextarea = false;
    var hasSubmit = false;
    var hasConsent = consentText;
    if (!hasConsent) {
        return false;
    }
    for (var i = 0; i < form.length; i++) {
        if (form[i].field_type === 'textfield') {
            hasInput = true;
        }
        else if (form[i].field_type === 'textarea') {
            hasTextarea = true;
        }
        else if (form[i].field_type === 'submitButton') {
            hasSubmit = true;
        }
    }
    return (hasInput || hasTextarea) && hasSubmit;
};
export function setUsesHtmlProperty(versionId, formEntries) {
    var usesHtmlTypes = ['alert', 'paragraph'];
    return formEntries.map(function (entry) {
        if (versionId && usesHtmlTypes.includes(entry.field_type)) {
            return __assign(__assign({}, entry), { usesHtml: true });
        }
        return entry;
    });
}
export function execFormRules(form, values) {
    /** using a lookup table 'parsedMap' as a much faster alternative to looping parsed to find targetForm on every iteration */
    var parsedMap = {};
    return form.reduce(function (parsed, entry) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var targetForm = parsedMap[(_a = entry.rule) === null || _a === void 0 ? void 0 : _a.qid];
        if (targetForm && ((_b = values === null || values === void 0 ? void 0 : values[entry.rule.qid]) === null || _b === void 0 ? void 0 : _b.type) === 'textInput') {
            if (((_c = entry.rule) === null || _c === void 0 ? void 0 : _c.action) === 'show') {
                if (targetForm.field_type === 'checkbox') {
                    var checkedValues = (_d = values === null || values === void 0 ? void 0 : values[entry.rule.qid]) === null || _d === void 0 ? void 0 : _d.value.split(',');
                    if (targetForm.show &&
                        checkedValues.indexOf(entry.rule.value) !== -1) {
                        entry.show = true;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                    else {
                        entry.show = false;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                }
                else {
                    if (!targetForm.show ||
                        ((_e = values === null || values === void 0 ? void 0 : values[entry.rule.qid]) === null || _e === void 0 ? void 0 : _e.value) !==
                            entry.rule.value) {
                        entry.show = false;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                    else {
                        entry.show = true;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                }
            }
            else if (((_f = entry.rule) === null || _f === void 0 ? void 0 : _f.action) === 'hide') {
                if (targetForm.field_type === 'checkbox') {
                    var checkedValues = (_g = values === null || values === void 0 ? void 0 : values[entry.rule.qid]) === null || _g === void 0 ? void 0 : _g.value.split(',');
                    if (!targetForm.show ||
                        checkedValues.indexOf(entry.rule.value) !== -1) {
                        entry.show = false;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                    else {
                        entry.show = true;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                }
                else {
                    if (targetForm.show &&
                        ((_h = values === null || values === void 0 ? void 0 : values[entry.rule.qid]) === null || _h === void 0 ? void 0 : _h.value) !==
                            entry.rule.value) {
                        entry.show = true;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                    else {
                        entry.show = false;
                        parsedMap[entry.qid] = entry;
                        parsed.push(entry);
                        return parsed;
                    }
                }
            }
            else {
                entry.show = true;
                parsedMap[entry.qid] = entry;
                parsed.push(entry);
                return parsed;
            }
        }
        entry.show = true;
        parsedMap[entry.qid] = entry;
        parsed.push(entry);
        return parsed;
    }, []);
}
export function getFileId(file) {
    return "".concat(file.name).concat(file.size).concat(file.type).concat(file.lastModified);
}
